import styled from "styled-components";

export const CONSENT_STATUSES = ["consent", "no_consent", "unknown"];

export const ConsentDot = styled.span`
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const ConsentItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.65);
`;

export const toConsentValue = (status) => {
  if (status === "consent") return true;
  if (status === "no_consent") return false;
  return null;
};

export const getConsentColor = (isConsent) => {
  if (isConsent === true) return "#52c41a";
  if (isConsent === false) return "#ff4d4f";
  return "#bfbfbf";
};

export const getStatusTagColor = (status) => {
  const s = status?.toLowerCase() ?? "";
  if (["active", "valid", "good"].some((k) => s.includes(k))) return "success";
  if (
    [
      "invalid",
      "bounced",
      "disconnected",
      "unsubscribed",
      "inactive",
      "undeliverable",
      "bad",
      "wrong",
      "do_not",
    ].some((k) => s.includes(k))
  )
    return "error";
  if (["questionable", "uncertain", "pending"].some((k) => s.includes(k))) return "warning";
  return "default";
};
